import React from "react";

import { createCbTemplateControlProps } from "../../../../types/cb-template-control-props/cb-template-control-props.functions";
import { CbTemplateViewProps } from "../../../../types/cb-template-view/cb-template-view.props";

import { CbTemplateControlAdditionalCreativeReqs } from "../../../cb-template-control/components/cb-template-control-additional-creative-reqs/cb-template-control-additional-creative-reqs.component";
import { CbTemplateControlAudience } from "../../../cb-template-control/components/cb-template-control-audience/cb-template-control-audience.component";
import { CbTemplateControlCampaignOverview } from "../../../cb-template-control/components/cb-template-control-campaign-overview/cb-template-control-campaign-overview.component";
import { CbTemplateControlContext } from "../../../cb-template-control/components/cb-template-control-context/cb-template-control-context.component";
import { CbTemplateControlLegalRequirements } from "../../../cb-template-control/components/cb-template-control-legal-requirements/cb-template-control-legal-requirements.component";
import { CbTemplateControlMandatoryCreativeReqs } from "../../../cb-template-control/components/cb-template-control-mandatory-creative-reqs/cb-template-control-mandatory-creative-reqs.component";
import { CbTemplateControlObjectives } from "../../../cb-template-control/components/cb-template-control-objectives/cb-template-control-objectives.component";
import { CbTemplateControlOfferDetails } from "../../../cb-template-control/components/cb-template-control-offer-details/cb-template-control-offer-details.component";
import { CbTemplateControlPrevResults } from "../../../cb-template-control/components/cb-template-control-prev-results/cb-template-control-prev-results.component";
import { CbTemplateControlPrimaryMessage } from "../../../cb-template-control/components/cb-template-control-primary-message/cb-template-control-primary-message.component";
import { CbTemplateControlSecondaryMessage } from "../../../cb-template-control/components/cb-template-control-secondary-message/cb-template-control-secondary-message.component";
import { CbTemplateControlStartEndDate } from "../../../cb-template-control/components/cb-template-control-start-end-date/cb-template-control-start-end-date.component";
import { CbTemplateLayout } from "../../../cb-template-layout/components/cb-template-layout/cb-template-layout.component";
import { CbTemplateLayoutLeft } from "../../../cb-template-layout/components/cb-template-layout-left/cb-template-layout-left.component";

import { CbTemplateStandardRightSection } from "../cb-template-standard-right-section/cb-template-standard-right-section.component";

export const CbTemplateGeneral = (props: CbTemplateViewProps) => {
  const controlProps = createCbTemplateControlProps(props);

  return (
    <CbTemplateLayout ndaData={props.ndaData}>
      <CbTemplateLayoutLeft>
        <CbTemplateControlCampaignOverview {...controlProps} />
        <CbTemplateControlStartEndDate {...controlProps} />
        <CbTemplateControlContext {...controlProps} />
        <CbTemplateControlObjectives {...controlProps} />
        <CbTemplateControlAudience {...controlProps} />
        <CbTemplateControlPrevResults {...controlProps} />
        <CbTemplateControlOfferDetails {...controlProps} />
        <CbTemplateControlPrimaryMessage {...controlProps} />
        <CbTemplateControlSecondaryMessage {...controlProps} />
        <CbTemplateControlMandatoryCreativeReqs {...controlProps} />
        <CbTemplateControlAdditionalCreativeReqs {...controlProps} />
        <CbTemplateControlLegalRequirements {...controlProps} />
      </CbTemplateLayoutLeft>

      <CbTemplateStandardRightSection {...props} />
    </CbTemplateLayout>
  );
};
